import React from 'react';
import style from './sceneNotice.scss';

function SceneNotice({ content }) {
    return (
        <div className={style.container}>
            <p className={style.notice}>
                {content}
            </p>
        </div>
    );

}

export default SceneNotice;
